import dayjs from "dayjs";

export const calendarMonths = [
  { key: "januari", value: 0 },
  { key: "februari", value: 1 },
  { key: "maart", value: 2 },
  { key: "april", value: 3 },
  { key: "mei", value: 4 },
  { key: "juni", value: 5 },
  { key: "juli", value: 6 },
  { key: "augustus", value: 7 },
  { key: "september", value: 8 },
  { key: "oktober", value: 9 },
  { key: "november", value: 10 },
  { key: "december", value: 11 },
];

interface YearValue {
  key: string;
  value: number;
}

export const generateYears = () => {
  const yearValue = dayjs().year(2024);
  const lengthOfYears = 6;
  const years: YearValue[] = [];

  for (let i = 0; i < lengthOfYears; i++) {
    const getDatValues = yearValue.add(i, "year");
    years.push({
      key: getDatValues.format("YYYY"),
      value: getDatValues.year(),
    });
  }
  return years;
};
